import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  button: {
    paddingBlock: theme.spacing(2),
    paddingInline: theme.spacing(8),
    borderRadius: theme.spacing(4),
  },
}))

export default styles
